import { Drawer } from "components/nav/drawer/drawer.component";
import { NavBar } from "components/nav/navBar/navBar.component";
import { useState } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import {
  PrivateRoute,
  PublicRoute,
} from "web-apps/company/components/customRoute/customRoute.component";
import { ApplicantDetailPage } from "./pages/application/applicantDetail.page";
import { ApplicationPage } from "./pages/application/application.page";
import { GigApplicantsPage } from "./pages/application/gigApplicants.page";
import { ChatPage } from "./pages/chat/chat.page";
import { ClockStampPage } from "./pages/clockStamp/clockStamp.page";
import { CompanySelectPage } from "./pages/companySelect/companySelect.page";
import { CompanySettingsPage } from "./pages/companySettings/companySettings.page";
import { DesignPage } from "./pages/design/design.page";
import { GigPage } from "./pages/gig/gig.page";
import { LoginPage } from "./pages/login/login.page";
import { OrganizationalStructurePage } from "./pages/organizationalStructure/organizationalStructure.page";
import { FavoritePage } from "./pages/profile/favorite/favorite.page";
import { FavoriteDetailPage } from "./pages/profile/favorite/favoriteDetail.page";
import { ProfilePage } from "./pages/profile/profile.page";
import { RegistrationPage } from "./pages/registration/registration.page";
import { SalaryPage } from "./pages/salary/salary.page";
import { SignUpPage } from "./pages/signUp/signUp.page";
import { ApplicationStoreProvider } from "./stores/applicationStore/applicationStore";
import { ChatStoreProvider } from "./stores/chatStore/chatStore";
import { CompanyStoreProvider } from "./stores/companyStore/companyStore";
import { MonthSalaryStoreProvider } from "./stores/monthSalaryStore/monthSalaryStore";
import { OrganizationalStructureStoreProvider } from "./stores/organizationalStructureStore/organizationalStructureStore";
import { ScheduleStoreProvider } from "./stores/schedule/scheduleStore";
import { StaffingWorkersStoreProvider } from "./stores/staffingStore/staffingWorkersStore";
import { TimeReportStoreProvider } from "./stores/timeReportStore/timeReportStore";
import { TimeReportsV2StoreProvider } from "./stores/timeReportsV2/timeReportsV2Store";
import { TipStoreProvider } from "./stores/tipStore/tipStore";
import { SchedulePage } from "./pages/schedule/schedule.page";
import { TimeReportsV2Page } from "./pages/timereports/timeReportsV2.page";
import { AnalyticsPage } from "./pages/analytics/analytics.page";

export const CompanyApp = () => {
  const { path } = useRouteMatch();
  const [open, setOpen] = useState(false);
  const hostname: string =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isProd: boolean = hostname === "app.simflexity.com";

  return (
    <CompanyStoreProvider>
      <ChatStoreProvider>
        <ApplicationStoreProvider>
          <TimeReportStoreProvider>
            <TimeReportsV2StoreProvider>
              <MonthSalaryStoreProvider>
                <OrganizationalStructureStoreProvider>
                  <TipStoreProvider>
                    <StaffingWorkersStoreProvider>
                      <ScheduleStoreProvider>
                        <NavBar open={open} setOpen={setOpen} />
                        <Drawer open={open} setOpen={setOpen} />
                        <Switch>
                          <PublicRoute path={`${path}/login`}>
                            <LoginPage />
                          </PublicRoute>
                          <PublicRoute path={`${path}/sign-up`}>
                            <SignUpPage />
                          </PublicRoute>
                          <PrivateRoute path={`${path}/company-select`}>
                            <CompanySelectPage />
                          </PrivateRoute>
                          <PublicRoute path={`${path}/registration`}>
                            <RegistrationPage />
                          </PublicRoute>
                          <PrivateRoute path={`${path}/overview`}>
                            <div>Overview</div>
                          </PrivateRoute>
                          {!isProd && (
                            <PrivateRoute path={`${path}/design`}>
                              <DesignPage />
                            </PrivateRoute>
                          )}
                          <PrivateRoute path={`${path}/overview`}>
                            <div>Overview</div>
                          </PrivateRoute>
                          <PrivateRoute
                            path={`${path}/applications/application/:id`}
                            render={(props) => (
                              <ApplicantDetailPage {...props} />
                            )}
                          />
                          <PrivateRoute
                            path={`${path}/applications/:id`}
                            render={(props) => <GigApplicantsPage {...props} />}
                          />
                          <PrivateRoute path={`${path}/applications`}>
                            <ApplicationPage />
                          </PrivateRoute>

                          <PrivateRoute path={`${path}/stampclock`}>
                            <ClockStampPage />
                          </PrivateRoute>

                          <PrivateRoute path={`${path}/gigs`}>
                            <GigPage />
                          </PrivateRoute>
                          <PrivateRoute
                            path={`${path}/profile/favorites/:id`}
                            render={(props) => (
                              <FavoriteDetailPage {...props} />
                            )}
                          />
                          <PrivateRoute path={`${path}/profile/favorites`}>
                            <FavoritePage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/profile`}>
                            <ProfilePage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/settings`}>
                            <CompanySettingsPage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/chat`}>
                            <ChatPage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/schedule`}>
                            <SchedulePage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/time-reports`}>
                            <TimeReportsV2Page />
                          </PrivateRoute>
                          <PrivateRoute
                            path={`${path}/organizationalStructure`}
                          >
                            <OrganizationalStructurePage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/salary`}>
                            <SalaryPage />
                          </PrivateRoute>
                          <PrivateRoute path={`${path}/analytics`}>
                            <AnalyticsPage />
                          </PrivateRoute>
                        </Switch>
                      </ScheduleStoreProvider>
                    </StaffingWorkersStoreProvider>
                  </TipStoreProvider>
                </OrganizationalStructureStoreProvider>
              </MonthSalaryStoreProvider>
            </TimeReportsV2StoreProvider>
          </TimeReportStoreProvider>
        </ApplicationStoreProvider>
      </ChatStoreProvider>
    </CompanyStoreProvider>
  );
};
